import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter, Link } from 'react-router-dom';
import { GridWrapper, Heading, Alert, Text, Buttons, Button, Input, GridRow, GridColumn, ArrowLink } from 'react-onei';
import { isMobileOnly } from 'react-device-detect';

import ApiService from '../../../services/ApiService';
import Spinner from '../../Spinner/Spinner';
import UserContext from '../../../context/UserContext';
import TagService from '../../../services/TagService';
import { events } from '../../../conf/tags_ga.conf';
import { MOBILE_TYPE } from '../../../helpers/account';

export class OtpView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      otpcode: '',
      otcError: undefined,
      otcId: null,
      hasRetry: false,
      contact: props.location.state.contact,
      loading: true,
      requesting: false,
    };
    this.otcInput = React.createRef();
  }

  componentDidMount() {
    this.sendOtp();
  }

  /**
 * Send OTC to contact
 * @param {Object} contact 
 */
  sendOtp = async () => {
    const { contact } = this.state;
    const { history } = this.props;
    const { wording } = this.context;
    const { WLOST_330, WLOST_331, WLOST_332 } = wording;

    try {
      const res = await ApiService.createOtp({
        contactId: contact.contactId,
      });
      this.setState({
        otcId: res.data.data.resourceId,
        loading: false,
      });
    } catch (err) {
      const code = err.response?.data?.code;

      switch (code) {
        case 403002: // OPT Event blacklisted
          history.push({
            pathname: '/error',
            state: {
              title: WLOST_330,
              message: contact.contactType === MOBILE_TYPE ? WLOST_331 : WLOST_332,
            },
          });
          break;
        default:
          history.push({
            pathname: '/error',
            state: {
              code,
            }
          });
      }
    }
  };

  /**
   * Check otpcode state with contact OTC
   */
  checkOtc = async () => {
    const { history } = this.props;
    const { setStep } = this.context;
    const { otpcode, otcId } = this.state;
    const { wording } = this.context;
    const { WLOST_333, WLOST_334, WLOST_335, WLOST_336, WLOST_306, WLOST_307, WLOST_308, WBUTTON_005 } = wording;

    this.setState({ requesting: true });
    try {
      const res = await ApiService.checkOtpCode({
        otpsId: otcId,
        otpcode,
      });
      const { step } = res.data;

      // Autorize next pathname
      setStep(`/${step}`);
      // Go to next step
      history.push(`/${step}`);
    } catch (err) {
      const code = err.response?.data?.code;

      switch (code) {
        case 403002: // OPT Event blacklisted
          history.push({
            pathname: '/error',
            state: {
              title: WLOST_333,
              message: WLOST_334,
            },
          });
          break;
        case 412002: // Empty code
          this.setState({ otcError: WLOST_306 })
          break;
        case 412004: // Not a number code
          this.setState({ otcError: WLOST_307 })
          break;
        case 412005: // Invalid code
          this.setState({ otcError: WLOST_308 })
          break;
        case 412301: // Expire code
          history.push({
            pathname: '/error',
            state: {
              title: WLOST_335,
              message: WLOST_336,
              buttonLabel: WBUTTON_005,
            },
          })
          break;
        default:
          history.push({
            pathname: '/error',
            state: {
              code,
            }
          });
          break;

      }
    }
    this.setState({ requesting: false });
  }

  /**
   * Set state otpcode on input change
   * @param e
   */
  handleChange = (e) => {
    const { value } = e.target;
    const { wording } = this.context;
    const { WLOST_307 } = wording;

    this.setState({
      otpcode: value.trim(),
      otcError: !(/^\d+$/.test(value)) ? WLOST_307 : undefined,
      isSubmitted: false,
    });
  };

  /**
   * Submit the user OTC, check if corresponding to the one sent
   * @param e
   */
  handleSubmit = (e) => {
    const { wording } = this.context;
    const { WLOST_306 } = wording;
    const { otpcode } = this.state;
    e.preventDefault();
    TagService.sendEvent(events.checkCode);

    if (!otpcode) {
      this.setState({ otcError: WLOST_306 });
      this.otcInput.current.blur();
    } else {
      this.checkOtc();
    }
  };

  /**
   * Set an input error when no code is filled on blur
   * Clear existing errors
   * @param e
   */
  handleBlur = (e) => {
    const { otpcode } = this.state;
    const { wording } = this.context;
    const { WLOST_306 } = wording;

    if (e.relatedTarget && (e.relatedTarget.type === "button" || e.relatedTarget.type === "submit" || e.relatedTarget.tagName === "A")) {
      return
    } else if (!otpcode) {
      this.setState({ otcError: WLOST_306 });
    }
  };

  /**
   * Fucntion to send a new OTC, clear OTC otpcode and error when exist
   */
  handleRetry = async () => {
    const { history } = this.props;
    const { contact } = this.state;
    const { wording } = this.context;
    const { contactId } = contact;
    const { WLOST_330, WLOST_331, WLOST_332 } = wording;

    TagService.sendEvent(events.retryCode);
    this.setState({
      otpcode: '',
      otcError: undefined,
    });

    try {
      const res = await ApiService.retryOtp({ contactId });
      this.setState({
        otcId: res.data.data.resourceId,
        hasRetry: true
      }, () => {
        setTimeout(() => {
          this.setState({ hasRetry: false });
        }, 10000);
      })
    } catch (err) {
      const code = err.response?.data?.code;
      switch (code) {
        case 403002: // OPT Event blacklisted
          history.push({
            pathname: '/error',
            state: {
              title: WLOST_330,
              message: contact.contactType === MOBILE_TYPE ? WLOST_331 : WLOST_332,
            },
          });
          break;
        default:
          history.push({
            pathname: '/error',
            state: {
              code,
            }
          });
      }
    }
  };

  handleBackToChoice = () => {
    const { setStep } = this.context;

    TagService.sendEvent(events.otpContactListLink);
    setStep('/choice');
  }

  render() {
    const { contact, loading, otcError, hasRetry, requesting } = this.state;
    const { wording } = this.context;
    const { WLOST_200, WLOST_301, WLOST_302, WLOST_303, WLOST_304, WLOST_305, WLOST_310, WLOST_311, WLOST_312, WLOST_320, WBUTTON_001 } = wording;

    if (loading) {
      return <Spinner />;
    }

    return (
      <GridWrapper>
        <form id="otc-form" onSubmit={this.handleSubmit} method="post">

          <GridRow>
            <GridColumn>
              <Heading as="h3" id="otc-subtitle" className="spacing-m">{WLOST_200}</Heading>
              <Text id="otc-message">
                {`${contact.contactType === MOBILE_TYPE ? WLOST_301 : WLOST_302} ${contact.contactView}`}
              </Text>
            </GridColumn>
          </GridRow>

          <GridRow>
            <GridColumn size={{ xs: 1, m: 4 / 12 }}>
              <Input
                autoFocus
                ref={this.otcInput}
                error={otcError}
                onBlur={this.handleBlur}
                onChange={this.handleChange}
                id="otc-input"
                name="otc-input"
                label={contact.contactType === MOBILE_TYPE ? WLOST_303 : WLOST_304}
                helper={WLOST_305}
                displayOptionalLabel={false}
                maxLength={254}
              />
              {hasRetry && (
                <Alert
                  mini
                  variant="success"
                  id="otc-retry-notification"
                  role="alert"
                  title={contact.contactType === MOBILE_TYPE ? WLOST_310 : WLOST_311}
                  className="spacing-xs"
                />
              )}
            </GridColumn>
          </GridRow>

          <GridRow>
            <GridColumn>
              <Buttons direction={isMobileOnly ? 'vertical' : 'horizontal'} className="spacing-s">
                <Button id="otc-submit-button" type="submit" disabled={requesting}>
                  {WBUTTON_001}
                </Button>
                <Button variant="wired" id="otc-retry-button" type="reset" onClick={this.handleRetry}>
                  {WLOST_312}
                </Button>
              </Buttons>
            </GridColumn>
          </GridRow>

          <GridRow>
            <GridColumn>
              <ArrowLink
                href=""
                as={Link}
                to="/choice"
                id="back-to-canal"
                aria-label={WLOST_320}
                title={WLOST_320}
                variant="previous"
                fullWidth
                className="spacing-s"
                onClick={this.handleBackToChoice}
              >
                {WLOST_320}
              </ArrowLink>
            </GridColumn>
          </GridRow>

        </form >
      </GridWrapper>
    )
  }
}

OtpView.propTypes = {
  location: PropTypes.shape({
    state: PropTypes.shape({
      contact: PropTypes.object.isRequired,
    }),
  }).isRequired,
  history: PropTypes.object.isRequired,
};

OtpView.contextType = UserContext;

export default withRouter(OtpView);
